import ApiConnection from './connection';



const getPatientData = async ({ cpf: cpf_user }) => {
  try {
    const response = await ApiConnection.post('/patients/get-patient-by-cpf', { cpf_patient: cpf_user });
    return response.data;
  } catch (error) {

    return null; // Retorna null para manter a consistência do retorno
  }
};
const vinculateUserPatient = async ({ id: id_user, username, ip }) => {
  try {
    const response = await ApiConnection.post('/patients/vinculate-user-patient', { id: id_user, username, ip });

    return {
      output: response.data,
      status: response.status,
      message: response?.data?.mensagem || null,
    };
  } catch (error) {
    console.warn('Erro ao tentar vincular paciente:', error);

    // Tenta extrair o status do erro, ou define como 500 se não tiver
    const status = error?.response?.status || 500;
    const message = error?.response?.data?.mensagem || 'Erro inesperado';

    return { status, message, output: null };
  }
};


export default function patient() {
  return {
    getPatientData,
    vinculateUserPatient,
  };
}
